var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.retailerPage)?[_c('Navbar'),_c('ContactsModal'),_c('CartModal'),_c('main',[_vm._t("default")],2),_c('Footer')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }